import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import { SidebarActions, ActionButton } from '../../SidebarActions';
import actions from './actions';
import AddPhoto from '../../../../assets/svg/AddPhoto';
import ArrowUpRight from '../../../../assets/svg/Feather/ArrowUpRight';
import Center from '../../../../assets/svg/Remix/Center';
import HuntsIcon from '../../../../assets/svg/HuntsIcon';
import Pencil from '../../../../assets/svg/Feather/Pencil';
import styles from './FeatureDetailActions.module.scss';
import Trash2 from '../../../../assets/svg/Feather/Trash2';

export const FeatureDetailActions = (props) => {

  const editFeature = () => {
    props.toggleEditFeature();
  };

  const showDeleteModal = () => {
    props.showDeleteModal(props.selectedFeature, props.previousView);
  };

  const showAddToCollectionModal = () => {
    props.showAddToCollectionModal({...props.selectedFeature});
  };

  const openFileExplorer = () => {
    document.getElementById('fileElement').click();
  };

  const uploadPhoto = (e) => {
    const files = e.target.files;
    props.processPhoto(files, props.selectedFeature);
  };

  const goToCenter = () => {
    props.goToCenter(props.selectedFeature);
  };

  const leaveFeature = () => {
    props.showLeftShare(props.selectedFeature);
  };

  return (
    <div className={styles.container}>
      <SidebarActions>
        {props.selectedFeature && props.selectedFeature.isOwner ? (  
          <>
            <ActionButton icon={Pencil} active={props.isEditingFeature} onClick={editFeature}>
              Edit
            </ActionButton>
            <ActionButton icon={HuntsIcon} onClick={showAddToCollectionModal}>
              Add To
            </ActionButton>
            <ActionButton icon={Center} onClick={goToCenter}>
              Focus
            </ActionButton>
            <div>
              <input
                id='fileElement'
                type='file'
                accept='image/png, image/jpeg, image/jpg'
                onChange={(e) => uploadPhoto(e)}
                hidden
              />
              <ActionButton icon={AddPhoto} className={styles.photoButton} onClick={openFileExplorer}>
                Photo
              </ActionButton>
            </div>
            <ActionButton icon={Trash2} onClick={showDeleteModal}>
              Delete
            </ActionButton>
          </>
        ) : (
          <>
            <ActionButton icon={Center} onClick={goToCenter}>
              Focus
            </ActionButton>
            <ActionButton icon={ArrowUpRight} onClick={leaveFeature}>
              Leave
            </ActionButton>
          </>
        )}
      </SidebarActions>

    </div>
  );
};

FeatureDetailActions.propTypes = {
  currentView: PropTypes.string,
  isEditingFeature: PropTypes.bool,
  previousView: PropTypes.string,
  selectedFeature: PropTypes.object,
  // actions
  goToCenter: PropTypes.func,
  processPhoto: PropTypes.func,
  showAddToCollectionModal: PropTypes.func,
  showDeleteModal: PropTypes.func,
  showLeftShare: PropTypes.func,
  toggleEditFeature: PropTypes.func,
};

export default connect((model) => {
  const { sidebarHistoryStack, sidebarView } = model.app
  const { isEditingFeature, selectedFeature } = model.features
  const currentView = sidebarView.view
  const previousView = sidebarHistoryStack[0] && sidebarHistoryStack[0].view
  return {
    currentView,
    isEditingFeature,
    previousView,
    selectedFeature,
  };
}, actions)(FeatureDetailActions);